module.exports = __webpack_public_path__ + "static/media/appts-list.7d5eab05.svg";